<template>
  <va-create-layout>
    <path-form :title="title" :item="item"></path-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"]
};
</script>
